/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    background: {
      description: 'Background colour of box. White if not specified.',
      type: 'variant',
      values: [
        'lightest',         'lighter',
        'light',            'dark',
        'darker',           'darkest',
        'critical',         'danger',
        'warning',          'positive',
        'brand',            'white',
        'black',            'featurePrimary',
        'featureSecondary', 'featureNeutral',
        'featureBrand'
      ]
    }
  },
  rules: [
    {
      if: { background: 'lightest' },
      tokens: { backgroundColor: '#ffffff', borderColor: '#ffffff' }
    },
    {
      if: { background: 'lighter' },
      tokens: { backgroundColor: '#fafafa', borderColor: '#fafafa' }
    },
    {
      if: { background: 'light' },
      tokens: { backgroundColor: '#efefef', borderColor: '#efefef' }
    },
    {
      if: { background: 'dark' },
      tokens: { backgroundColor: '#666666', borderColor: '#666666' }
    },
    {
      if: { background: 'darker' },
      tokens: { backgroundColor: '#595959', borderColor: '#595959' }
    },
    {
      if: { background: 'darkest' },
      tokens: { backgroundColor: '#000000', borderColor: '#000000' }
    },
    {
      if: { background: 'critical' },
      tokens: { backgroundColor: '#c9370b', borderColor: '#c9370b' }
    },
    {
      if: { background: 'danger' },
      tokens: { backgroundColor: '#fcd3c6', borderColor: '#fcd3c6' }
    },
    {
      if: { background: 'warning' },
      tokens: { backgroundColor: '#fff5d2', borderColor: '#fff5d2' }
    },
    {
      if: { background: 'positive' },
      tokens: { backgroundColor: '#c5f2cc', borderColor: '#c5f2cc' }
    },
    {
      if: { background: 'brand' },
      tokens: { backgroundColor: '#7a3dfc', borderColor: '#7a3dfc' }
    },
    {
      if: { background: 'white' },
      tokens: { backgroundColor: '#ffffff', borderColor: '#ffffff' }
    },
    {
      if: { background: 'black' },
      tokens: { backgroundColor: '#000000', borderColor: '#000000' }
    },
    {
      if: { background: 'featurePrimary' },
      tokens: { backgroundColor: '#a1ed00', borderColor: '#a1ed00' }
    },
    {
      if: { background: 'featureSecondary' },
      tokens: { backgroundColor: '#ff0076', borderColor: '#ff0076' }
    },
    {
      if: { background: 'featureNeutral' },
      tokens: { backgroundColor: '#ffad00', borderColor: '#ffad00' }
    },
    {
      if: { background: 'featureBrand' },
      tokens: { backgroundColor: '#e0d8fc', borderColor: '#e0d8fc' }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: 'rgba(0, 0, 0, 0)',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    gradient: null
  }
}
export default theme
